// extracted by mini-css-extract-plugin
export default {"auth":"Login_auth__eQkWf","user":"Login_user__2RO9T","banner":"Login_banner__HokdM","link":"Login_link__K4ylC"};